// extracted by mini-css-extract-plugin
export var fadeInAnimation = "MobileNav-module--fadeInAnimation--ac48e";
export var mobileNav = "MobileNav-module--mobileNav--5dcb9";
export var panel = "MobileNav-module--panel--fa1b4";
export var parent = "MobileNav-module--parent--bdee2";
export var visible = "MobileNav-module--visible--d2a45";